import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AboutSection } from './components/AboutSection';
import { InsightsSection } from './components/InsightsSection';
import { ProductsSection } from './components/ProductsSection';
import { GrowthSection } from './components/GrowthSection';
import { ConsultingSection } from './components/ConsultingSection';
import { Footer } from './components/Footer';
import { NewsfiliatePage } from './pages/NewsfiliatePage';
import { NewsfilatePrivacyPolicyPage } from './pages/NewsfilatePrivacyPolicyPage';
import { NewsfilateTermsOfServicePage } from './pages/NewsfilateTermsOfServicePage';
import { NewsfilateUpdatePage } from './pages/NewsfilateUpdatePage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { InsightsPage } from './pages/InsightsPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { AiNewsletterBlogPost } from './pages/AiNewsletterBlogPost';
import { MonetizationStrategiesBlogPost } from './pages/MonetizationStrategiesBlogPost';
import { AffiliateLinksPage } from './pages/AffiliateLinksPage';
import { SponsorshipPilotPage } from './pages/SponsorshipPilotPage';
import { SmartSegmentationPage } from './pages/SmartSegmentationPage';
import { InsightPage } from './pages/InsightPage';
function HomePage() {
  const location = useLocation();
  useEffect(() => {
    // Handle hash scrolling when page loads with a hash
    if (location.hash) {
      const sectionId = location.hash.substring(1);
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [location.hash]);
  return <div className="w-full min-h-full bg-white font-sans" data-id="element-0">
      <Header data-id="element-1" />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <Hero data-id="element-3" />
        <AboutSection data-id="element-4" />
        <InsightsSection data-id="element-5" />
        <ProductsSection data-id="element-6" />
        <GrowthSection data-id="element-7" />
        <ConsultingSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-10">
      <Routes data-id="element-11">
        <Route path="/" element={<HomePage data-id="element-13" />} data-id="element-12" />
        <Route path="/products/newsfiliate" element={<NewsfiliatePage data-id="element-15" />} data-id="element-14" />
        <Route path="/products/newsfiliate/update" element={<NewsfilateUpdatePage data-id="element-17" />} data-id="element-16" />
        <Route path="/newsfiliate/privacy-policy" element={<NewsfilatePrivacyPolicyPage data-id="element-19" />} data-id="element-18" />
        <Route path="/newsfiliate/terms-of-service" element={<NewsfilateTermsOfServicePage data-id="element-21" />} data-id="element-20" />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-23" />} data-id="element-22" />
        <Route path="/terms-of-service" element={<TermsOfServicePage data-id="element-25" />} data-id="element-24" />
        <Route path="/insights" element={<InsightsPage data-id="element-27" />} data-id="element-26" />
        <Route path="/insights/can-you-include-amazon-affiliate-links-in-emails" element={<BlogPostPage data-id="element-29" />} data-id="element-28" />
        <Route path="/insights/how-ai-can-improve-your-newsletter-content-creation" element={<AiNewsletterBlogPost data-id="element-31" />} data-id="element-30" />
        <Route path="/insights/monetization-strategies-for-creator-newsletters-in-2025" element={<MonetizationStrategiesBlogPost data-id="element-33" />} data-id="element-32" />
        <Route path="/affiliate-links" element={<AffiliateLinksPage data-id="element-35" />} data-id="element-34" />
        <Route path="/sponsorship-pilot-program" element={<SponsorshipPilotPage data-id="element-37" />} data-id="element-36" />
        <Route path="/smart-segmentation" element={<SmartSegmentationPage data-id="element-39" />} data-id="element-38" />
        <Route path="/insight" element={<InsightPage data-id="element-41" />} data-id="element-40" />
      </Routes>
    </BrowserRouter>;
}